export default __webpack_public_path__ + "static/media/featuredRaceMobile.882875b1.png";